import React from 'react'
import { render } from 'react-dom'
import ReactResizeDetector from 'react-resize-detector'
import { CacheProvider } from '@emotion/react'
import { PAYPAL_THEME, ThemeWrapper } from '@paypalcorp/pp-react'
import createCache from '@emotion/cache'

import ErrorBoundary from 'components/ErrorBoundary'
import ErrorFallback from 'views/Shopping/components/ErrorFallback'
import { RewardsTermsAndConditions } from './shoplist-app/rewards-terms-and-conditions/components/RewardsTermsAndConditions'
import ResizeObserverContext from './lib/resize-observer-context'
import PortalFooter from './shoplist-app/shopping/components/v2/PortalFooter'

render(
  <ErrorBoundary FallbackComponent={() => <ErrorFallback useGenericError />}>
    <CacheProvider value={createCache({ key: 'rewards-terms', prepend: true })}>
      <ReactResizeDetector handleWidth>
        {({ width }: { width: number }) => (
          <ResizeObserverContext.Provider value={width}>
            <div id="resize-observer">
              <ThemeWrapper theme={PAYPAL_THEME}>
                <RewardsTermsAndConditions />
                <PortalFooter />
              </ThemeWrapper>
            </div>
          </ResizeObserverContext.Provider>
        )}
      </ReactResizeDetector>
    </CacheProvider>
  </ErrorBoundary>,
  document.getElementById('root')
)
